var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskTechnicalBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1502.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,28.216H50.4q15.447,0,23.175,6.375T81.3,54.615q0,9.753-3.375,15.226a22.932,22.932,0,0,1-9.974,8.625q16.5,5.7,16.5,24.45,0,15.6-8.25,22.35t-23.85,6.75H12.75Zm37.2,10.2H24.3v35.85H51q9.6,0,14.026-4.576t4.424-13.8q0-9.226-4.725-13.35T49.95,38.416Zm1.2,45.9H24.3v37.5H51.9q10.2,0,15.524-4.274t5.326-15.075a19.489,19.489,0,0,0-2.175-9.6,12.627,12.627,0,0,0-5.776-5.55A32.655,32.655,0,0,0,51.15,84.315Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2,132.016v-75h11.1v10.2a73.086,73.086,0,0,1,27.45-11.851v11.4a80.877,80.877,0,0,0-13.125,3.75,87.237,87.237,0,0,0-10.425,4.5l-3.75,1.95v55.05Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.6,122.716l4.351-.45.3,8.849a215.525,215.525,0,0,1-29.25,2.4q-16.2,0-22.951-9.375T144.3,94.966q0-39.45,31.35-39.45,15.15,0,22.65,8.474t7.5,26.625l-.6,8.551H155.7q0,12.452,4.5,18.449t15.675,6Q187.047,123.615,198.6,122.716Zm-4.05-32.55q0-13.8-4.424-19.5t-14.4-5.7q-9.976,0-15,6t-5.175,19.2Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,79.666v38.4q.45,5.553,8.7,6.6l-.451,8.85q-11.85,0-17.849-6a65.986,65.986,0,0,1-27,6q-10.352,0-15.75-5.85t-5.4-16.8q0-10.947,5.55-16.125t17.4-6.375l23.549-2.25V79.666q0-7.651-3.3-10.95t-9-3.3a215.9,215.9,0,0,0-24.9,1.5l-4.649.449-.45-8.55a151.3,151.3,0,0,1,29.25-3.3q12.747,0,18.524,5.849T273.3,79.666Zm-46.2,30.6q0,13.8,11.4,13.8a60.635,60.635,0,0,0,20.1-3.45l3.45-1.2V94.666l-22.2,2.1q-6.75.6-9.75,3.9T227.1,110.266Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.546,55.516a129.547,129.547,0,0,1,16.8,1.8l3.6.451-.45,9.15a176.08,176.08,0,0,0-17.7-1.351q-12.75,0-17.324,6.076t-4.575,22.5q0,16.425,4.274,22.875t17.776,6.45l17.7-1.351.45,9.3a154.612,154.612,0,0,1-20.85,2.1q-17.552,0-24.225-9t-6.675-30.375q0-21.375,7.2-30T320.546,55.516Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.145,132.016H354.9V24.315h11.25v36.9q12-5.7,23.1-5.7,15,0,20.174,8.1t5.175,28.8v39.6h-11.25v-39.3q0-15.6-3.075-21.375T387.3,65.565A49.972,49.972,0,0,0,369,69.016l-2.851,1.049Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.943,92.266v39.75h-11.55V28.216h38.4q16.5,0,24.825,7.649t8.325,23.851q0,24-19.05,30.149l19.95,42.151h-12.75l-18.75-39.75Zm27-10.2q21.15,0,21.15-21.825t-21.3-21.824h-26.85V82.065Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.842,40.065V27.016h11.25V40.065Zm0,91.951v-75h11.25v75Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.242,65.565q-16.351,0-16.35,11.4,0,5.252,3.75,7.425t17.1,4.5q13.349,2.326,18.9,6.525t5.55,15.75q0,11.552-7.425,16.949t-21.675,5.4a135.889,135.889,0,0,1-21.9-2.1l-4.5-.75.6-9.75q17.1,2.552,25.8,2.55t13.275-2.776q4.575-2.772,4.575-9.3t-3.9-8.85q-3.9-2.325-17.1-4.426t-18.75-6.149q-5.55-4.05-5.55-15t7.725-16.2q7.724-5.248,19.275-5.25a158.017,158.017,0,0,1,22.95,2.1l4.2.75-.3,9.6A195.438,195.438,0,0,0,575.242,65.565Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.691,132.016h-11.25V24.315h11.25v63.6l11.7-.6,21.45-30.3h12.75l-24.45,34.5,25.5,40.5h-12.75l-22.349-34.8-11.851.45Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.862,26.655v-4.6h18.4v4.6H697.19V49.472h-5.061V26.655Zm21.252,22.908V22.056h6.624l6.072,19.135,6.531-19.135h6.441V49.563H727V28.956l-6.073,19.228H716.97L710.9,28.956V49.563Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.952,51.3V33h75V51.3h-27V135h-20.7V51.3Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869,135V33h66V51H889.7V74.851H926v17.7H889.7V117H935v18Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013,133.351a136.584,136.584,0,0,1-28.65,3.449q-12.752,0-20.4-3.15a25.148,25.148,0,0,1-12-10.049,44.626,44.626,0,0,1-6-16.2A137.47,137.47,0,0,1,944.3,84q0-29.548,8.325-41.175T983.3,31.2q12.9,0,29.85,4.05l-.6,16.5a170.376,170.376,0,0,0-24.675-2.25q-9.827,0-14.025,2.625T967.624,62.1Q965.6,69.451,965.6,87.15t4.125,24.525q4.123,6.828,16.5,6.825a176.966,176.966,0,0,0,26.325-2.1Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.449,135V92.7H1047.5V135h-20.7V33h20.7V74.7h37.95V33h20.7V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.347,135V33h34.95l24.6,84h1.5V33h20.7V135h-34.05l-25.5-84h-1.5v84Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.3,135V33H1247V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.845,133.351a136.592,136.592,0,0,1-28.65,3.449q-12.752,0-20.4-3.15a25.148,25.148,0,0,1-12-10.049,44.662,44.662,0,0,1-6-16.2,137.367,137.367,0,0,1-1.65-23.4q0-29.548,8.325-41.175T1301.145,31.2q12.9,0,29.85,4.05l-.6,16.5a170.364,170.364,0,0,0-24.675-2.25q-9.826,0-14.025,2.625T1285.47,62.1q-2.025,7.35-2.025,25.049t4.125,24.525q4.123,6.828,16.5,6.825a176.966,176.966,0,0,0,26.325-2.1Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.1,135l22.95-102h39.3l22.95,102h-20.7l-4.05-18.45h-35.7L1356.8,135Zm39-84.9-10.35,48.449h27.9L1382.3,50.1Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.993,135h-58.05V33h20.7v83.7h37.349Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskTechnicalBanner);
export default __webpack_public_path__ + "static/media/BreachRisk_Technical_Banner.9b1a624a72be0c73f691a0f09f4d9e3c.svg";
export { ForwardRef as ReactComponent };